const BaseAPI = 'https://clientapi.timeinlive.com/api/'; //production
//const BaseAPI = 'http://clientdevapi.timeinlive.com/api/'; //dev server
//const BaseAPI = 'http://192.168.1.8:8000/api/';  // danapal

export default BaseAPI;

    
  